import { render, staticRenderFns } from "./AMResetPwdFormComponent.vue?vue&type=template&id=d6d28276&scoped=true"
import script from "./AMResetPwdFormComponent.vue?vue&type=script&lang=js"
export * from "./AMResetPwdFormComponent.vue?vue&type=script&lang=js"
import style0 from "./AMResetPwdFormComponent.vue?vue&type=style&index=0&id=d6d28276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d28276",
  null
  
)

export default component.exports